import { render, staticRenderFns } from "./mall-appointment-dialog.vue?vue&type=template&id=6261f4a2&scoped=true"
import script from "./mall-appointment-dialog.vue?vue&type=script&lang=js"
export * from "./mall-appointment-dialog.vue?vue&type=script&lang=js"
import style0 from "./mall-appointment-dialog.vue?vue&type=style&index=0&id=6261f4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6261f4a2",
  null
  
)

export default component.exports